export const BirthTypes = {
  SOLAR: "solar",
  LUNAR: "lunar",
};

export const TEST_TYPES = {
  DAILY: "dailyTest",
  YEAR: "2026Test",
  DOB: "dobTest",
  LOTTO_DRAW: "lottoDrawTest",
  NAME: "nameTest",
  NAME_PREMIUM: "namePremiumTest",
  REAL_ESTATE: "realEstateTest",
  REAL_ESTATE_BUSINESS_FIT: "realEstateBusinessFitTest",

  TOTAL_FORTUNE_BASIC_TEST: "totalFortuneBasicTest",
  TOTAL_FORTUNE_PREMIUM_TEST: "totalFortunePremiumTest",

  MONEY_DEEP_ANALYSIS: "moneyDeepAnalysisTest",
  CAREER_DEEP_ANALYSIS: "careerDeepAnalysisTest",
  LOVE_DEEP_ANALYSIS: "loveDeepAnalysisTest",
  MATCH_DEEP_ANALYSIS: "matchDeepAnalysisTest",
  CAUTION_DEEP_ANALYSIS: "cautionDeepAnalysisTest",

  NEXT_DAY_WITH_TIME_DAILY_TEST: "nextDayWithTimeDailyTest",
  NEXT_DAY_NO_TIME_DAILY_TEST: "nextDayNoTimeDailyTest",
  DATE_BASED_WITH_TIME_DAILY_TEST: "dateBasedWithTimeDailyTest",
  DATE_BASED_NO_TIME_DAILY_TEST: "dateBasedNoTimeDailyTest",
  ONE_MONTH_WITH_TIME_DAILY_TEST: "oneMonthWithTimeDailyTest",
  ONE_MONTH_NO_TIME_DAILY_TEST: "oneMonthNoTimeDailyTest",
  THREE_MONTH_WITH_TIME_DAILY_TEST: "threeMonthWithTimeDailyTest",
  THREE_MONTH_NO_TIME_DAILY_TEST: "threeMonthNoTimeDailyTest",

  DATE_BASED_MARRIAGE_TEST: "dateBasedMarriageTest",
  ONE_YEAR_MARRIAGE_TEST: "oneYearMarriageTest",
  THREE_MONTH_MARRIAGE_TEST: "threeMonthMarriageTest",
  ONE_MONTH_MARRIAGE_TEST: "oneMonthMarriageTest",
};

export const EXTENDED_DAILY_PREMIUM_FORTUNE_TEST_TYPE = {
  NEXT_DAY: "nextDay",
  DATE_BASED: "dateBased",
  ONE_MONTH: "oneMonth",
  THREE_MONTH: "threeMonth",
};

export const DAILY_FORTUNES_WITH_AND_WITHOUT_TIME = {
  NEXT_DAY_WITH_TIME_DAILY_TEST: "nextDayWithTimeDailyTest",
  NEXT_DAY_NO_TIME_DAILY_TEST: "nextDayNoTimeDailyTest",
  DATE_BASED_WITH_TIME_DAILY_TEST: "dateBasedWithTimeDailyTest",
  DATE_BASED_NO_TIME_DAILY_TEST: "dateBasedNoTimeDailyTest",
  ONE_MONTH_WITH_TIME_DAILY_TEST: "oneMonthWithTimeDailyTest",
  ONE_MONTH_NO_TIME_DAILY_TEST: "oneMonthNoTimeDailyTest",
  THREE_MONTH_WITH_TIME_DAILY_TEST: "threeMonthWithTimeDailyTest",
  THREE_MONTH_NO_TIME_DAILY_TEST: "threeMonthNoTimeDailyTest",
};

export const DAILY_FORTUNES_ONE_AND_THREE_MONTHS = {
  ONE_MONTH_WITH_TIME_DAILY_TEST: "oneMonthWithTimeDailyTest",
  ONE_MONTH_NO_TIME_DAILY_TEST: "oneMonthNoTimeDailyTest",
  THREE_MONTH_WITH_TIME_DAILY_TEST: "threeMonthWithTimeDailyTest",
  THREE_MONTH_NO_TIME_DAILY_TEST: "threeMonthNoTimeDailyTest",
};

export const PREMIUM_MARRIAGE_FORTUNE_TESTS = {
  DATE_BASED_MARRIAGE_TEST: "dateBasedMarriageTest",
  ONE_MONTH_MARRIAGE_TEST: "oneMonthMarriageTest",
  THREE_MONTH_MARRIAGE_TEST: "threeMonthMarriageTest",
  ONE_YEAR_MARRIAGE_TEST: "oneYearMarriageTest",
};

export const DAILY_CATEGORY_TYPE = {
  TODAY: "dailyToday",
  TEST: "dailyTest",
  MOVE: "dailyMove",
  MONEY: "dailyMoney",
  LOVE: "dailyLove",
  HEALTH: "dailyHealth",
  COMPANY: "dailyCompany",
  ALL: "dailyAll",
};

export const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
